import React from 'react';
import { Form, Card } from 'react-bootstrap';

/**
 * Araç formlarında kullanılan Diğer Bilgiler formu
 * 
 * @param {Object} props.data - Form verisi (formData veya vehicle)
 * @param {Function} props.handleChange - Input değişikliklerini yakalayan fonksiyon
 */
const VehicleAdditionalForm = ({ data, handleChange }) => {
    return (
        <Card className="mb-4">
            <Card.Header>Diğer Bilgiler</Card.Header>
            <Card.Body>
                <Form.Group className="mb-3" controlId="features">
                    <Form.Label>Özellikler (virgülle ayırın)</Form.Label>
                    <Form.Control
                        type="text"
                        name="features"
                        value={data.features || ''}
                        onChange={handleChange}
                        placeholder="Örn: Sunroof, Deri koltuk, Geri görüş kamerası"
                    />
                </Form.Group>

                <Form.Group className="mb-3" controlId="description">
                    <Form.Label>Açıklama</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={5}
                        name="description"
                        value={data.description || ''}
                        onChange={handleChange}
                        placeholder="Araç hakkında detaylı bilgi verin"
                        required
                    />
                </Form.Group>
            </Card.Body>
        </Card>
    );
};

export default VehicleAdditionalForm;